export interface MatchParts {
  pre: string;
  hit: string;
  post: string;
}

// Splits a label around the first case-insensitive occurrence of the query so the
// hero search panel can mark the matched run (design `hi()`): "Hotels" for "tel" →
// { pre: "Ho", hit: "tel", post: "s" }. No query, or no match, returns the whole
// label as `pre`.
export function highlightMatch(label: string, query: string): MatchParts {
  const q = query.trim().toLowerCase();
  const i = q ? label.toLowerCase().indexOf(q) : -1;
  if (i < 0) return { pre: label, hit: '', post: '' };
  return { pre: label.slice(0, i), hit: label.slice(i, i + q.length), post: label.slice(i + q.length) };
}
